module.exports = __webpack_public_path__ + "static/img/200310.1005bb8b.png";